// extracted by mini-css-extract-plugin
module.exports = {"Jen":"TextGroupSectionA_Jen__jk4Dr","TextContainer":"TextGroupSectionA_TextContainer__1x_mU"};